// extracted by mini-css-extract-plugin
module.exports = {"required":"styles_required__21v2w"};